import { getToken as getUserToken, lock as userLock } from './PasswordGate';
import { getDeviceToken, isOnKioskRoute } from './deviceToken';

// Wraps fetch for our authenticated endpoints. Adds the Bearer token
// automatically and, for non-kiosk routes, clears the local credential
// on 401 so the password gate can re-render.
//
// Two credential sources, picked by URL:
//   /kiosk*  → device token (long-lived, read-only)
//   anything else → user session token (PasswordGate)
//
// Kiosk 401s do NOT clear the device token. Once a kiosk has been linked
// it must never drop back to the enrollment screen — the only acceptable
// post-link states are the dashboard and the lock overlay. A persistent
// 401 surfaces as the dashboard's "Offline" indicator (KioskShell flips
// `offline = true` on any non-OK response) and the kiosk keeps polling
// until the backend recovers.

function pickToken(): { token: string | null; kiosk: boolean } {
  if (isOnKioskRoute()) {
    return { token: getDeviceToken(), kiosk: true };
  }
  return { token: getUserToken(), kiosk: false };
}

export async function apiFetch(
  input: RequestInfo | URL,
  init: RequestInit = {}
): Promise<Response> {
  const { token, kiosk } = pickToken();
  const headers = new Headers(init.headers ?? {});
  if (token && !headers.has('Authorization')) {
    headers.set('Authorization', `Bearer ${token}`);
  }
  const res = await fetch(input, { ...init, headers });
  if (res.status === 401 && !kiosk) {
    userLock();
    if (typeof window !== 'undefined') window.location.reload();
  }
  return res;
}
